import { Component, input } from '@angular/core';
import { ListingVendor } from '../../../core/models/listing-vendor';
import { NgClass, NgOptimizedImage, UpperCasePipe } from '@angular/common';
import { CantonPipe } from '../../../core/pipes/canton.pipe';

@Component({
  selector: 'app-vendor-card',
  imports: [NgClass, NgOptimizedImage, CantonPipe, UpperCasePipe],
  template: `
    <a
      class="group relative block aspect-video overflow-hidden rounded-xl md:aspect-5/7"
      [ngClass]="{ 'cursor-default': !vendor().bookings_are_public }"
      [attr.href]="
        vendor().bookings_are_public ? '/louer-salle/' + vendor().slug : null
      "
      [attr.target]="vendor().bookings_are_public ? '_blank' : undefined"
    >
      <!-- Image -->
      <img
        [ngSrc]="vendor()?.photo"
        fill
        sizes="100vw"
        class="rounded-xl object-cover duration-300 ease-out group-hover:origin-center group-hover:scale-110"
        alt="{{ vendor().listing_name }}"
        title="{{ vendor().listing_name }}"
        [ngClass]="{ 'group-hover:grayscale': !vendor().bookings_are_public }"
      />

      <!-- Overlay gradient pour améliorer la lisibilité du texte -->
      <div
        class="absolute inset-x-0 bottom-0 h-2/3 bg-linear-to-t from-stone-900 to-transparent"
      ></div>

      <!-- Texte animé -->
      <div class="absolute bottom-0 z-20 w-full px-4 md:px-6">
        <div class="flex flex-col transition-transform duration-300">
          <!-- Listing name, toujours visible -->
          <span
            class="block -translate-y-6 text-lg text-white transition-transform duration-300 xl:translate-y-2 xl:text-xl xl:group-hover:-translate-y-6"
          >
            <div class="text-sm font-medium">
              {{ vendor()?.canton | canton | uppercase }}
            </div>
            <div class="leading-none font-bold">{{
              vendor().listing_name
            }}</div>
          </span>
          <!-- "3 salles à louer" descend au départ et remonte au hover -->
          <span
            class="block -translate-y-4 font-medium text-yellow-300 transition-all duration-300 xl:translate-y-4 xl:opacity-0 xl:group-hover:-translate-y-4 xl:group-hover:opacity-100"
          >
            @if (vendor().bookings_are_public) {
              {{ vendor().roomsCount }}
              {{ vendor().roomsCount > 1 ? 'salles' : 'salle' }} à louer
            } @else {
              Locations privées
            }
          </span>
        </div>
      </div>
    </a>
  `,
  styles: ``,
})
export class VendorCardComponent {
  vendor = input.required<ListingVendor>();
}
